import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { NearestLocationFinder } from './NearestLocationFinder';
export function ContactSection() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormState({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
      setTimeout(() => setIsSuccess(false), 5000);
    }, 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact" className="py-20 md:py-28 bg-white" data-id="element-133">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-135">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-section-mobile md:text-section text-brand-dark mb-4" data-id="element-136">
            Get in Touch
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-subtitle text-neutral-text/80" data-id="element-137">
            Ready to book an appointment or have a question? We're here to help.
          </motion.p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20" data-id="element-138">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:w-1/2" data-id="element-139">
            <div className="bg-surface-muted p-8 rounded-card shadow-sm" data-id="element-140">
              <h3 className="text-2xl font-heading font-semibold text-brand-dark mb-6" data-id="element-141">
                Send us a Message
              </h3>

              {isSuccess ? <div className="bg-green-100 text-green-800 p-4 rounded-md mb-6 flex items-center gap-3" data-id="element-142">
                  <div className="w-8 h-8 bg-green-200 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-143">
                    ✓
                  </div>
                  <p data-id="element-144">
                    Thank you! Your message has been sent. We'll be in touch
                    shortly.
                  </p>
                </div> : null}

              <form onSubmit={handleSubmit} className="space-y-5" data-id="element-145">
                <div data-id="element-146">
                  <label htmlFor="name" className="block text-sm font-medium text-neutral-text mb-1" data-id="element-147">
                    Full Name *
                  </label>
                  <input type="text" id="name" name="name" required value={formState.name} onChange={handleChange} className="w-full px-4 py-3 rounded-button border border-gray-300 focus-ring bg-white" placeholder="John Doe" data-id="element-148" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-149">
                  <div data-id="element-150">
                    <label htmlFor="email" className="block text-sm font-medium text-neutral-text mb-1" data-id="element-151">
                      Email Address *
                    </label>
                    <input type="email" id="email" name="email" required value={formState.email} onChange={handleChange} className="w-full px-4 py-3 rounded-button border border-gray-300 focus-ring bg-white" placeholder="john@example.com" data-id="element-152" />
                  </div>
                  <div data-id="element-153">
                    <label htmlFor="phone" className="block text-sm font-medium text-neutral-text mb-1" data-id="element-154">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" name="phone" value={formState.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-button border border-gray-300 focus-ring bg-white" placeholder="(301) 324-9500" data-id="element-155" />
                  </div>
                </div>
                <div data-id="element-156">
                  <label htmlFor="message" className="block text-sm font-medium text-neutral-text mb-1" data-id="element-157">
                    How can we help? *
                  </label>
                  <textarea id="message" name="message" required rows={4} value={formState.message} onChange={handleChange} className="w-full px-4 py-3 rounded-button border border-gray-300 focus-ring bg-white resize-none" placeholder="I'd like to schedule an eye exam..." data-id="element-158"></textarea>
                </div>
                <button type="submit" disabled={isSubmitting} className="w-full bg-brand-gold text-white py-4 rounded-button font-heading font-semibold hover:bg-brand-gold-light transition-colors focus-ring disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-159">
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </motion.div>

          {/* Find Nearest Clinic */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:w-1/2" data-id="element-160">
            <div className="[&>section]:py-0 [&>section]:border-0 [&>section]:bg-transparent" data-id="element-161">
              <NearestLocationFinder data-id="element-162" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}